<template>
  <CContainer fluid>
    <CRow>
      <CCol col="sm-6" sm="6">
        <CInput 
          label="Buscar:" 
          :value.sync="searchWord" 
          @keyup.enter="getData(1, searchWord)">
          <template #prepend-content>
            <a href="#" @click="getData(1)">
              <i class="bi bi-arrow-clockwise"></i>
            </a>
          </template>
          <template #append-content>
            <a href="#" @click="getData(1, searchWord)">
              <i class="bi bi-search"></i>
            </a>
          </template>
        </CInput>
      </CCol>
    </CRow>

    <CDataTable 
      hover
      class="table-hover-icons"
      :responsive=true
      :fields="fields" 
      :items="opportunities"
      :noItemsView="{ noItems: '' }"
      :items-per-page="itemsPerPage">
      <template #empresa="{ item }">
        <td>
          <h4>{{ item.empresa }}</h4>
          <div>
            <i class="bi bi-postcard mr-1"></i>
            <span>{{ item.identificacion }}</span>
          </div>
          <div>
            <i class="bi bi-person-workspace mr-1" />
            <span>{{ item.empleado }}</span>
          </div>
        </td>
      </template>
      <template #clasificacion="{item}">
        <td>
          <div>
            <span>{{ item.origen_Oportunidad }}</span>
          </div>
          <div>
            <span>{{ item.grupo_Oportunidad }}</span>
          </div>
          <div>
            <span>{{ item.fase_Venta }}</span>
          </div>
        </td>
      </template>
      <template #prioridad="{item}">
        <td>
          <div>
            <i class="bi bi-cash-coin mr-1" />
            <strong>{{ formatter.format(item.valor_NegocioPrevisto) }}</strong>
          </div>
          <div>
            <i class="bi bi-calendar3 mr-1"></i>
            <span>{{ moment(item.fecha_Creacion).format("DD/MM/YYYY") }}</span>
          </div>
          <div>
            <CBadge :color="getColor(item.prioridad)" v-if="item.prioridad">
              {{ opportunityStatus[item.prioridad] }}
            </CBadge>
          </div>
        </td>
      </template>
    </CDataTable>
    <CPagination 
      size="sm"
      class="d-flex justify-content-center"
      :activePage.sync="page" 
      :pages="pageCount" 
      @update:activePage="(value, a) => getData(value, searchWord)" />

    <LoadingCover v-show="loading" />
  </CContainer>
</template>

<style scoped>
  @import "../../../../assets/css/table-hover-actions.css";
</style>

<script>
  import { ref } from "vue";
  import moment from "moment";
  
  import LoadingCover from "@/components/containers/LoadingCover.vue";

  import { 
    errorMessage,
    formatter
  } from "@/general"
  import { 
    dataGridOportunidades
  } from "@/api"

  const fields = [
    { 
      key: 'empresa', 
      label: 'Empresa', 
      _style:'text-align:center;'
    },
    { 
      key: 'clasificacion', 
      label: 'Clasificación', 
      _style:'text-align:center;'
    },
    { 
      key: "prioridad",
      label: "Prioridad",
      _style:"text-align:center;"
    }
  ]

  export default {
    name: "OpportunitiesQuery",
    data() {
      return {
        formatter,
        loading: false,
        page: 1,
        pageCount: 1,
        itemsPerPage: 5,
        searchWord: "",
        opportunities: [],
        fields,
        opportunityStatus: {
          'M': 'Muy Importante',
          'I': 'Importante',
          'B': 'Baja'
        }
      }
    },
    props: {
      IdEmployee: String,
      IdDirectory: String,
      IdCampaign: String,
      InitDate: String,
      EndDate: String
    },
    components: {
      LoadingCover
    },
    methods: {
      moment,
      async getData(page, search) {
        this.loading = true;
        this.searchWord = search;

        const filters = {
          "Id_Personal": this.IdEmployee,
          "Id_Directorio": this.IdDirectory,
          "Id_Campania": this.IdCampaign,
          "Id_OrigenOportunidad": undefined,
          "Id_GrupoOportunidad": undefined,
          "Id_FaseVenta": undefined
        };

        console.log("Filtros ", filters);
        

        try {
          const { count, results } = await dataGridOportunidades(this, page, search, filters);
          
          this.pageCount = parseInt(count / this.itemsPerPage)
          if (this.pageCount < (count / this.itemsPerPage)) {
            this.pageCount++
          }
          this.opportunities = results;
        } catch (error) {
          this.$store.commit('setAlert', {
            color: "danger",
            message: errorMessage(error),
            show: 5
          })
        } finally {
          this.loading = false
        }
      },
      getColor(status) {
        if(status === 'M') return 'success'
        if(status === 'I') return 'warning'
        if(status === 'B') return 'default'
      }
    },
    setup() {
      const rootPath = ref("");

      return {
        rootPath
      }
    },
    mounted() {
      this.rootPath = this.$router.currentRoute.fullPath;

      this.getData();
    }
  }
</script>
